export namespace Chart {
  export enum Type {
    line = 'line',
    column = 'column',
    bar = 'bar',
  }
}
